import { Component, OnInit } from '@angular/core';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { EnvService } from '../service/env.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-invalid-page',
  templateUrl: './invalid-page.component.html',
  styleUrls: ['./invalid-page.component.scss']
})
export class InvalidPageComponent implements OnInit {

  accountDetail: any;

  constructor(private apiService: ApiService, private authService: AuthenticationService, public utilService: UtilService, private env: EnvService) { }

  ngOnInit(): void {
    this.accountDetail = this.apiService.accountDetail;
    setTimeout(() => {
      this.logout();
    }, this.env.UNSUPPORTED_USER_AUTO_LOGOUT_TIME);
  }

  logout() {
    this.authService.logout();
    this.apiService.reset();
  }

}
